import { RoleId } from '@wix/members-domain-ts';
import { MemberRole } from '../../controller/services/comments-service';
export const mapMemberRoleToMaRole = (role) => {
    switch (role) {
        case MemberRole.OWNER:
            return RoleId.ADMIN;
        case MemberRole.CONTRIBUTOR:
            return RoleId.ADMIN;
        case MemberRole.BLOG_WRITER:
            return RoleId.SET_BLOG_WRITER;
        case MemberRole.BLOG_EDITOR:
            return RoleId.SET_BLOG_EDITOR;
        case MemberRole.FORUM_MODERATOR:
            return RoleId.SET_FORUM_MODERATOR;
        default:
            return undefined;
    }
};
//# sourceMappingURL=map-member-role-to-ma-role.js.map